import { useDispatch } from "react-redux";
import { openAuth } from "../../../../../dataManagement/uiDb/GeneralDb";
import genericUtility from "../../../../../services/utility/GenericUtility";

export const useAuthOffer = () => {
  const dispatch = useDispatch();

  const navigateToLoginForOffer = () => {
    genericUtility.setOriginFrom(window.location.pathname);
    dispatch(openAuth());
  };

  return {
    navigateToLoginForOffer,
  };
};
